import React from 'react';
import { translate } from 'react-i18next';
import { Button, ButtonGroup } from 'react-bootstrap';
import Constants from '../../config/constants';

/***
 * Handle zooming and rotation
 */
export class EditorCanvas extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      changeAngleMode: false,
      groupAngleX: Constants.SC_EDITOR_GROUP_ANGLE_X,
      groupAngleY: Constants.SC_EDITOR_GROUP_ANGLE_Y,
      zoomLevel: Constants.SC_EDITOR_ZOOM,
    };
  }

  onAngleBegin(x, y) {
    this.setState({
      ...this.state,
      changeAngleMode: true,
      startX: x,
      startY: y,
    });
  }

  onAngleEnded() {
    this.setState({
      ...this.state,
      changeAngleMode: false,
      startX: null,
      startY: null,
    });
  }

  onAngleChanged(x, y) {
    if (this.state.changeAngleMode) {
      const newGroupAngleY = this.state.groupAngleY + (x - this.state.startX) * Constants.SC_EDITOR_SCALE_ANGLE;
      const newGroupAngleX = this.state.groupAngleX + (y - this.state.startY) * Constants.SC_EDITOR_SCALE_ANGLE;
      this.setState({
        groupAngleX: Math.round(Math.min(Math.max(newGroupAngleX, Constants.SC_EDITOR_ANGLE_X_MIN), Constants.SC_EDITOR_ANGLE_X_MAX)),
        groupAngleY: Math.round(Math.min(Math.max(newGroupAngleY, Constants.SC_EDITOR_ANGLE_Y_MIN), Constants.SC_EDITOR_ANGLE_Y_MAX)),
      });
    }
  }

  onZoomLevelChanged(deltaZoomLevel) {
    const newZoomLevel = this.state.zoomLevel + deltaZoomLevel * Constants.SC_EDITOR_SCALE_ZOOM;
    this.setState({
      zoomLevel: Math.min(Math.max(newZoomLevel, Constants.SC_EDITOR_ZOOM_MIN), Constants.SC_EDITOR_ZOOM_MAX),
    });
  }

  renderIndicator() {
    const { t } = this.props;
    const { groupAngleX, groupAngleY, zoomLevel } = this.state;
    const displayZoom = Math.round((zoomLevel - Constants.SC_EDITOR_ZOOM_MIN) / Constants.SC_EDITOR_ZOOM_STEP) + 1;
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', width: 400 }}>
        <span style={{ padding: 4 }}>{`${t('angle')} X: ${groupAngleX} °`}</span>
        <span style={{ padding: 4 }}>{`${t('angle')} Y: ${groupAngleY} °`}</span>
        <span style={{ padding: 4 }}>{`${t('zoom level')} : ${displayZoom}`}</span>
      </div>
    );
  }

  renderPresets() {
    const { t } = this.props;
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <ButtonGroup id="presets">
          <Button
            onClick={() => this.setState({ groupAngleX: 0, groupAngleY: 0 })}
          >
            {t('front')}
          </Button>
          <Button
            onClick={() => this.setState({ groupAngleX: 0, groupAngleY: Constants.SC_EDITOR_ANGLE_Y_MAX })}
          >
            {t('left')}
          </Button>
          <Button
            onClick={() => this.setState({ groupAngleX: 0, groupAngleY: Constants.SC_EDITOR_ANGLE_Y_MIN })}
          >
            {t('right')}
          </Button>
          <Button
            onClick={() => this.setState({ groupAngleX: Constants.SC_EDITOR_GROUP_ANGLE_X, groupAngleY: Constants.SC_EDITOR_GROUP_ANGLE_Y })}
          >
            {t('isometric')}
          </Button>
        </ButtonGroup>
      </div>
    );
  }

  render() {
    const { groupAngleX, groupAngleY, zoomLevel } = this.state;
    const { showIndicator, showPresets, width, height } = this.props;

    return (
      <React.Fragment>
        <div style={{ display: 'flex', justifyContent: 'space-between', zIndex: 1000 }}>
          {showIndicator && this.renderIndicator()}
          {showPresets && this.renderPresets()}
        </div>
        <div
          className="sc-wrapper"
          onMouseDown={({ clientX, clientY }) => this.onAngleBegin(clientX, clientY)}
          onMouseMove={({ clientX, clientY }) => this.onAngleChanged(clientX, clientY)}
          onMouseUp={() => this.onAngleEnded()}
          onWheel={({ deltaY }) => this.onZoomLevelChanged(deltaY)}
          onTouchStart={({ targetTouches }) => targetTouches.length === 1 && this.onAngleBegin(targetTouches[0].clientX, targetTouches[0].clientY)}
          onTouchMove={({ targetTouches }) => this.onAngleChanged(targetTouches[0].clientX, targetTouches[0].clientY)}
          onTouchEnd={() => this.onAngleEnded()}
        >
          <div
            className="group"
            style={{
              transform: `rotateX(${groupAngleX}deg) rotateY(${groupAngleY}deg)`,
              fontSize: `${zoomLevel}em`,
              width: `${width}em`,
              height: `${height}em`,
            }}
          >
            {this.props.children}
            <div
              className="axis axis-z"
              style={{
                width: `${width}em`,
                height: `${height * 2}em`,
              }}
            >
              <label
                style={{
                  transform: `rotateY(${180 - groupAngleY}deg) rotateX(${groupAngleX}deg)`,
                }}>Z</label>
            </div>
            <div
              className="axis axis-x"
              style={{
                width: `${width}em`,
                height: `${height * 2}em`,
                transform: `translateZ(${height}em) translateY(${-height}em) rotateX(90deg)`,
              }}
            >
              <label
                style={{
                  transform: `rotateX(${90 - groupAngleX}deg) rotateY(${groupAngleY}deg)`,
                }}>X</label>
            </div>
            <div
              className="axis axis-y"
              style={{
                width: `${width * 2}em`,
                height: `${height}em`,
              }}
            >
              <label
                style={{
                  transform: `rotateX(${180 - groupAngleX}deg) rotateY(${groupAngleY}deg)`,
                }}>Y</label>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

EditorCanvas.defaultProps = {
  showIndicator: false,
  showPresets: false,
  width: 16,
  height: 8,
};

export default translate('translations')(EditorCanvas);



// WEBPACK FOOTER //
// ./src/components/sc_editor/EditorCanvas.js